/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
// import { XdaStringsService } from '../../services/xda-strings.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'print-options-modal',
  templateUrl: './print-options-modal.component.html',
  styleUrls: ['./print-options-modal.component.less'],
  standalone: false,
})
export class PrintOptionsModalComponent implements OnInit, OnDestroy {
  @Input() param: any;
  @Input() selectedValue: any;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.selectedValue = this.param.selectedValue ?? '';
  }

  setValue(option: any) {
    this.selectedValue = option;
  }

  closeModal() {
    this.activeModal.close(this.selectedValue);
  }

  ngOnDestroy() {}
}
